import styled from "@emotion/styled";
import { MDSIconButton } from "@/mds/components/buttons";

const THUMBNAIL_BORDER = 2;

export const StyledCarouselContainer = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  flex-shrink: 0;
`;

export const StyledCarouselArrow = styled.div<{ isHidden: boolean }>`
  visibility: ${({ isHidden }) => (isHidden ? "hidden" : "visible")};
`;

export const StyledCarouselArrowButton = styled(MDSIconButton)`
  background-color: ${({ theme }) => theme.colors.background.toolbar};
`;

export const StyledCarouselStrip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding: ${({ theme }) => theme.spacing["2"]};

  /* Make the Document wrapper div invisible to flex layout */
  & > div {
    display: contents;
  }
`;

export const StyledCarouselThumbnail = styled.button<{ isActive: boolean }>`
  border: ${THUMBNAIL_BORDER}px solid
    ${({ theme, isActive }) =>
      isActive ? theme.colors.border.emphasis : theme.colors.border.default};
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  background: none;
  outline: none;
  /* Prevent layout shift while pages load */
  overflow: hidden;

  &:hover {
    border-color: ${({ theme, isActive }) =>
      isActive ? theme.colors.border.emphasis : theme.colors.border.onAccent};
  }
`;
